import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  Typography,
} from '@mui/material';
import { formatQueryError } from 'renderer/shared/formatters/formatters';
import { PaymentMethod } from '../schemas/paymentMethods.schemas';
import { useDeletePaymentMethodMutation } from '../services/paymentMethods.endpoints';

interface DeleteCardDialogProps {
  open: boolean;
  onClose: () => void;
  card?: PaymentMethod;
}

const DeleteCardDialog: React.FC<DeleteCardDialogProps> = ({
  open,
  onClose,
  card,
}) => {
  const [deleteCard, { isLoading, isSuccess, error, reset }] =
    useDeletePaymentMethodMutation();

  useEffect(() => {
    if (isSuccess) {
      onClose();
      reset();
    }
  }, [isSuccess, onClose, reset]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Card</DialogTitle>
      <DialogContent>
        {card && (
          <DialogContentText>
            Are you sure you want to remove your card ending in {card.last4}?
          </DialogContentText>
        )}
        {error && (
          <Alert severity="error">
            <Typography>
              We encountered an error while attempting to delete this payment
              method: {formatQueryError(error)}
            </Typography>
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        {card && (
          <Button
            onClick={() => {
              deleteCard(card._id);
            }}
            disabled={isLoading}
            color="error"
          >
            Delete
          </Button>
        )}
        <Button disabled={isLoading} onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCardDialog;
